<template>
  <v-flex :xs11="!full" class="wrap">
    <div
      :style="'left:' + paddingLeftPercent + ';width:' + dateRangeWidthPercent"
      class="date-range-area"
    >
      <slot style="min-height:28px; position: absolute;" />
    </div>
  </v-flex>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    displayStartDate: {
      type: String,
      default: '',
    },
    displayEndDate: {
      type: String,
      default: '',
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dateRange() {
      // display枠から外に完全に飛び出すならreturn0
      if (
        dayjs(this.endDate).isBefore(this.displayStartDate) ||
        dayjs(this.startDate).isAfter(this.displayEndDate)
      ) {
        return 0
      }
      // display枠から外にちょっと飛び出すならそこを切り取る
      const start = dayjs(this.startDate).isBefore(this.displayStartDate)
        ? this.displayStartDate
        : this.startDate
      const end = dayjs(this.endDate).isAfter(this.displayEndDate)
        ? this.displayEndDate
        : this.endDate
      return dayjs(end).diff(start, 'seconds')
    },
    displayDateRange() {
      return dayjs(this.displayEndDate).diff(this.displayStartDate, 'seconds')
    },
    startPositionDate() {
      return dayjs(this.startDate).diff(this.displayStartDate, 'seconds')
    },
    endPositionDate() {
      return dayjs(this.displayEndDate).diff(this.endDate, 'seconds')
    },
    paddingLeftPercent() {
      // 最小0
      let result = this.startPositionDate / this.displayDateRange
      result = result > 0 ? result : 0
      return result * 100 + '%'
    },
    dateRangeWidthPercent() {
      // 最大100
      let result = this.dateRange / this.displayDateRange
      result = result < 1 ? result : 1
      return result * 100 + '%'
    },
  },
}
</script>

<style scoped>
.wrap {
  position: relative;
  overflow-x: hidden;
}
.date-range-area {
  position: absolute;
  min-height: 28px;
}
</style>
